<div class="db-booster-optimization-status" [ngClass]="{'forHosting': forHosting}">
  <db-optimization-levels
    *ngIf="frontEndMenu" [maxOptimizedPagesLength]="maxOptimizedPagesLength"
    [websiteCDNEnabled]="websiteCDNEnabled" [boosterPluginIsActive]="boosterPluginIsActive"
    [boosterPluginIsOld]="boosterPluginIsOld" [websiteIsStaging]="websiteIsStaging"
    [websiteId]="websiteId" [websiteUrl]="websiteUrl" [websiteHosted]="isHosted"
    [userSubscription]="userSubscription" [notOptimizedPagesCount]="notOptimizedPagesCount"
    [cdnIsActive]="cdnIsActive" [adminActivateBoosterUrl]="adminActivateBoosterUrl"></db-optimization-levels>
<!--  <ng-container [ngTemplateOutlet]="cdnOptim"
                *ngIf="(userSubscription?.trialBoosterClient || (!!isHosted && frontEndMenu)) && boosterPluginIsActive && !websiteCDNEnabled">
  </ng-container>-->
  <div class="db-incognito-mode mt20" *ngIf="(boosterPluginIsActive || boosterPluginIsOld) && frontEndMenu && showIncognitoMode
  && (userSubscription?.trialBoosterClient || userSubscription?.boosterProClient || !!isHosted)">
    <div>
    <!--<i class="db-icon db-icon-ds-icon-incognito"></i>-->
      <img class="db-incognito-img" src="assets/images/icons/incognito.svg" alt="">
      <span>
        <p>{{'text_checkIncognitoMode' | dbText}}</p>
        <p>
          <span *ngIf="testMode === 'on' && showTestMode"  [innerHTML]="('text_testModeDesc' | dbText: {companyName: companyName}) + '<br>'"></span>
          <span>{{'text_changeOptimizationLevel' | dbText}}</span>
        </p>
      </span>
    </div>
  </div>
<!--  <div class="ds-notification-success mb25" *ngIf="testMode === 'on' && showTestMode">
    <div>
      <i class="db-icon db-icon-ds-checkmark-bg mb14"></i>
      <p>
        <span class="small"><b>10Web Booster is in test mode, optimization is disabled for website visitors.</b><br/>
          Change optimization levels and test them on your site in <a (click)="changeTab('settings')"><b>Settings.</b></a>
         </span>
      </p>
    </div>
  </div> -->





  <h3 *ngIf="!frontEndMenu">{{ 'text_websiteOptimizationStatus' | dbText}}</h3>
  <p *ngIf="!frontEndMenu">{{'text_websiteOptimizationStatusDesc' | dbText}}</p>

  <div *ngIf="!frontEndMenu" class="mt35 db-booster-optimization-status__progress">
    <div class="db-booster-optimization-status__progress-bar">
      <div class="progress passed" [ngClass]="{'test-mode': testMode === 'on' && showTestMode}"></div>
      <div class="checkmark passed" [ngClass]="{'test-mode': testMode === 'on' && showTestMode}">
        <div>
          <div><i class="db-icon db-icon-ds-checkmark"></i></div>
        </div>
      </div>
      <div class="progress" [ngClass]="{'passed': userSubscriptionType === UserSubscriptionType.PLATFORM || isHosted, 'test-mode': testMode === 'on' && showTestMode}"></div>
      <div class="checkmark" [ngClass]="{'passed': userSubscriptionType === UserSubscriptionType.PLATFORM || isHosted, 'test-mode': testMode === 'on' && showTestMode}">
        <div>
          <div><i class="db-icon db-icon-ds-checkmark"></i></div>
        </div>
      </div>
      <div class="progress" [ngClass]="{'passed': isHosted, 'test-mode': testMode === 'on' && showTestMode}"></div>
      <div class="star" [ngClass]="{'passed': isHosted, 'test-mode': testMode === 'on' && showTestMode}">
        <div><i class="db-icon db-icon-ds-star"></i></div>
      </div>
    </div>

    <div class="db-booster-optimization-status__progress-desc">
      <div>
        <div>
          <p>{{isHosted ? ('text_website' | dbText) : (optimizedPages$ | async)?.length ? ('text_homeOptimizedPages' | dbText: {optimizedPages: (optimizedPages$ | async)?.length}) : ('text_home_page' | dbText) }}</p>
          <span class="passed" [ngClass]="{'test-mode': testMode === 'on' && showTestMode}">{{ 'text_optimized' | dbText }}</span>
        </div>

      </div>
      <div>
        <div>
          <p *ngIf="isHosted || userSubscriptionType === UserSubscriptionType.PLATFORM">{{ 'text_frontendSpeedOptimization' | dbText }}</p>
          <p class="db-with-offer" *ngIf="!isHosted && userSubscriptionType !== UserSubscriptionType.PLATFORM" (click)="redirectToBoosterPro()">
            {{pageCount ? ('text_optimizePageCount' | dbText: {pageCount: pageCount}) : 'text_optimizeAllPages' | dbText }}</p>
          <span [ngClass]="{'passed': isHosted, 'test-mode': testMode === 'on' && showTestMode}">
            {{(isHosted ? 'text_allPagesOptimized2' : 'text_wb_subscription_plan_point2')  | dbText}}</span>
        </div>

      </div>
      <div>
        <div>
          <p>{{(isHosted ? 'text_backendSpeedOptimized' : 'Optimize backend speed') | dbText}}</p>
          <span [ngClass]="{'passed': isHosted, 'test-mode': testMode === 'on' && showTestMode}">{{'text_highPerformanceHosting' | dbText}}</span>
        </div>

      </div>
    </div>
  </div>

  <div class="mt20 ds-notification-{{cacheEnabled ? 'success success-notification' : 'warning'}}" *ngIf="!isHosted && cachingStatus && !frontEndMenu">
    <div>
      <i class="db-icon db-icon-{{cacheEnabled ? 'ds-checkmark-bg' : 'ds-info-bg'}}"></i>
      <span class="semibold">{{cacheEnabled ? ('text_cachingIsEnabledFoTheEntireWebsite' | dbText) : ('text_pageCacheDisabled' | dbText)}}</span>
    </div>
  </div>
</div>

<ng-template #cdnOptim>
  <div class="db-pro-optim-section-wrap mt25 mb25">
    <div class="db-pro-optim-section-wrap-header">
      <div class="db-pro-optim-section-text">
        <h4><i class="db-icon db-icon-ds-diamond"></i><span [innerHTML]="'text_proOptimCdnTile' | dbText"></span></h4>
        <p><span class="mb15" [innerHTML]="'text_proOptimCdnDesc' | dbText"></span></p>
      </div>
      <div class="db-pro-optim-section-btn" *ngIf="!websiteIsStaging">
        <button class="ds-btn-green" (click)="upgrade()">
          <span [innerHTML]="(((canEnable ? 'text_enableCDN' : !!isHosted ? 'text_buyNow' : 'text_upgrade') | dbText) | lowerCaseSpecificWords)"></span>
        </button>
      </div>
    </div>
    <div class="db-pro-optim-section-options mt25">
      <div class="db-pro-optim-section-option" [ngClass]="{'ds-lazy-load': pageCountLoading}" *ngFor="let option of options">
        <div class="db-pro-optim-section-option-text" [innerHTML]="option.text"></div>
        <img src="{{option.img}}" alt="img"/>
      </div>
    </div>
  </div>
</ng-template>
